import { isFulfilled } from '@reduxjs/toolkit'
import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useCallback, useState } from 'react'
import { useSelector } from 'react-redux'

import { requestGeneratePptxDocument, resetQbrPptxError } from 'partner360/features/QBR'
import {
  selectQbrDocumentUid,
  selectQBREntryId,
  selectQbrPptxReport,
  selectQbrPptxReportError,
  selectQbrPptxReportIsGeneratingStatus,
} from 'partner360/features/QBR/selectors'

import { downloadQbrPptxReport } from '../api/downloadQbrPptxReport'

export const useQbrDocumentExportActions = () => {
  /* ------------------ State ------------------ */
  const [isLoading, setIsLoading] = useState(false)

  /* ------------------ Selectors ------------------ */
  const documentId = useSelector(selectQBREntryId)
  const documentUid = useSelector(selectQbrDocumentUid)
  const pptxReportName = useSelector(selectQbrPptxReport)
  const isGenerating = useSelector(selectQbrPptxReportIsGeneratingStatus)
  const errorMessage = useSelector(selectQbrPptxReportError)

  /* ------------------ Custom hooks ------------------ */
  const dispatch = useAppDispatch()

  /* ------------------ Methods ------------------ */
  const clearResponseMessage = useCallback(() => {
    dispatch(resetQbrPptxError())
  }, [dispatch])

  const generateAndDownloadQbr = useCallback(async () => {
    if (documentId && documentUid) {
      const action = await dispatch(requestGeneratePptxDocument(documentId))
      if (isFulfilled(action)) {
        const pptxReportName = action.payload.pptxReport
        if (pptxReportName) {
          setIsLoading(true)
          await downloadQbrPptxReport(documentUid, pptxReportName)
          setIsLoading(false)
        }
      }
    }
  }, [dispatch, documentId, documentUid])

  /* ------------------ Result ------------------ */
  return {
    isLoading: isGenerating || isLoading,
    isPptxReportAvailable: pptxReportName !== null,
    errorMessage,
    clearResponseMessage,
    generateAndDownloadQbr,
    isDownloadingAvailable: documentId && documentUid,
  }
}
